import {error} from '../store/appActions';
import {push} from "connected-react-router";

export const fetchJson = (dispatch, url, fetchOptions, errorHandlers) => {
  return fetch(url, fetchOptions)
    .then(response => {
      if (response.ok) {
        if (response.headers.has('Content-Type') && response.headers.get('Content-Type').includes('application/json')) {
          return response.json()
            .then(json => {
              return {
                ok: true,
                json: json
              };
            }).catch(err => {
              error(`Error while parsing json from URL [${url}]`, err, dispatch);
              return {ok: false};
            });
        }
        return {ok: true};
      } else {
        if (response.status === 403) {
          dispatch(push('/login'));
          return {ok: false};
        } else {
          if (!errorHandlers || !Object.keys(errorHandlers).includes(response.status.toString())) {
            error(`Failed response for [${url}]`, response, dispatch);
          } else {
            errorHandlers[response.status.toString()]();
          }
          return {ok: false};
        }
      }
    }).catch(err => {
      error(`Error from [${url}]`, err, dispatch);
      return {ok: false};
    });
};


// WEBPACK FOOTER //
// ./src/util/fetch.js